// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"b2fa5553","231":"7ac1a8b0","244":"2de29f10","473":"81a612e9","538":"101ef112","680":"18998872","801":"fb7a8b30","807":"6fb6bb13","833":"94b892a6","891":"869f7a94"}[chunkId] + ".chunk.js";
};